import React, { MouseEvent } from "react";
import Link from "next/link";
import { Checkbox } from "components/atoms/Checkbox";
import { CheckboxType } from "components/atoms/Checkbox/types";
import ControlsContainer from "components/molecules/ControlsContainer";
import { ImageDTO } from "types";
import * as Styled from "./GalleryImage.styled";
interface GalleryImageProps {
  item: ImageDTO;
  toggles: Record<string, boolean>;
  isUserImage: (id: string) => boolean;
  handleToggle: (id: string) => void;
  handleEditClick: (id?: string) => void;
  handleADetailerClick: (id?: string) => void;
  handleFaceSwapClick: (id?: string) => void;
  handleBGRemovalClick: (id?: string) => void;
  handleInpaintClick: (id?: string) => void;
  handleUpscaleClick: (id?: string) => void;
  prepareForDelete: (id: string) => void;
  handleVote: (id: string) => void;
  onImageClick: (image: any) => void;
  isSelectionMode: boolean;
  handleSelectImage: (imageId: string) => void;
  isSelected: boolean;
  userGallery: boolean;
  handleShareClick: (e: React.MouseEvent, imageId?: string) => void;
  showIcons?: boolean;
  handleCompetitionsClick: () => void;
  showDeleteConfirmation: boolean;
}
const GalleryImage: React.FC<GalleryImageProps> = ({
  item,
  toggles,
  isUserImage,
  handleToggle,
  handleEditClick,
  handleADetailerClick,
  handleFaceSwapClick,
  handleBGRemovalClick,
  handleInpaintClick,
  handleUpscaleClick,
  prepareForDelete,
  handleVote,
  onImageClick,
  isSelectionMode,
  handleSelectImage,
  isSelected,
  userGallery,
  handleShareClick,
  showIcons = true,
  handleCompetitionsClick
}) => {
  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>, itemId: string) => {
    if (e.button === 1) {
      e.preventDefault();
      e.stopPropagation();
      window.open(`/images/${itemId}`, "_blank", "noopener,noreferrer");
    }
  };
  return <Styled.ImageWrapper key={item.id} data-sentry-element="unknown" data-sentry-component="GalleryImage" data-sentry-source-file="index.tsx">
            <Link href={`/images/${item.id}`} key={item.id} passHref data-sentry-element="Link" data-sentry-source-file="index.tsx">
                <Styled.LazyLoadImage src={item.image} alt={"Generated artwork"} loading="lazy" onClick={e => {
        if (e.button === 0) {
          // Prevent navigation on left click
          e.preventDefault();
        }
        // Handle other clicks normally
        isSelectionMode && userGallery ? handleSelectImage(item.id) : onImageClick(item);
      }} onAuxClick={e => handleMouseDown(e, item.id)} $isSelected={isSelected} data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
            </Link>
            {userGallery && <Checkbox type="checkbox" checked={isSelected} onChange={() => handleSelectImage(item.id)} className={isSelectionMode || isSelected ? "visible" : ""} id={`checkbox-${item.id}`} variant={CheckboxType.ERROR} />}
            {showIcons && <ControlsContainer imageInfo={item} toggles={toggles} handleToggle={handleToggle} handleShareClick={handleShareClick} handleCompetitionsClick={handleCompetitionsClick} handleEditClick={handleEditClick} handleADetailerClick={handleADetailerClick} handleFaceSwapClick={handleFaceSwapClick} handleBGRemovalClick={handleBGRemovalClick} handleInpaintClick={handleInpaintClick} handleUpscaleClick={handleUpscaleClick} prepareForDelete={prepareForDelete} handleVote={handleVote} isUserImage={isUserImage} />}
        </Styled.ImageWrapper>;
};
export default GalleryImage;